module.exports = __webpack_public_path__ + "static/media/WebDevelopmentLogo.46bacbc1.svg";